import React from 'react';
import { surfaceM, grayMediumM, primaryHighlightM, successM, backgroundTransparentM } from 'web-ui-kit/colors';
var VARIANTS = {
  "default": grayMediumM,
  primary: primaryHighlightM,
  success: successM,
  transparent: backgroundTransparentM,
  defaultTransparent: 'transparent',
  lightTransparent: 'rgba(28, 28, 28, 0.2)'
};

function CheckIcon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 40 : _ref$size,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      "aria-label": "check",
      className: className,
      role: "img",
      style: style,
      width: size,
      height: size,
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /*#__PURE__*/
    React.createElement("circle", {
      cx: "20",
      cy: "20",
      r: "20",
      fill: VARIANTS[variant] || VARIANTS["default"]
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M16.56 24.52L12.4133 20.3733L11 21.7867L16.56 27.3333L28.4933 15.4L27.08 14L16.56 24.52Z",
      fill: surfaceM
    }))
  );
}

export default CheckIcon;